var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('article', {
    staticClass: "position-relative d-flex flex-column justify-content-between product-item",
    on: {
      "~touchstart": function touchstart($event) {
        _vm.touch = true;
      },
      "mouseover": function mouseover($event) {
        return _vm.toggleImage(true);
      },
      "mouseleave": function mouseleave($event) {
        return _vm.toggleImage(false);
      }
    }
  }, [_c('div', {
    staticClass: "ratio-centered-img"
  }, [_vm.withWishlist ? _c('Heart', {
    staticClass: "position-absolute heart",
    attrs: {
      "reference": _vm.currentItem.reference
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ratio-image-child"
  }, [_vm.lazySeo && _vm.currentImage ? _c('img', {
    staticClass: "img-responsive",
    attrs: {
      "srcset": _vm.currentImage.srcset,
      "src": _vm.currentImage.xsmall,
      "alt": _vm.formattedName,
      "data-sizes": "auto",
      "loading": "lazy"
    }
  }) : _vm._e(), _vm._v(" "), _vm.lazyPoly && _vm.currentImage ? _c('img', {
    staticClass: "lazyload img-responsive",
    attrs: {
      "data-src": _vm.currentImage.xsmall,
      "data-srcset": _vm.currentImage.srcset,
      "alt": _vm.formattedName,
      "data-sizes": "auto"
    }
  }) : _vm._e(), _vm._v(" "), _vm.noLazy && _vm.currentImage ? _c('img', {
    staticClass: "img-responsive",
    attrs: {
      "srcset": _vm.currentImage.srcset,
      "src": _vm.currentImage.xsmall,
      "alt": _vm.formattedName,
      "sizes": "270px",
      "loading": "eager"
    }
  }) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-column details text-md-center"
  }, [_vm.variantsVisibility ? [_c('div', {
    staticClass: "rounded-variants pt-1 pb-1",
    on: {
      "mouseover": function mouseover($event) {
        _vm.hoverVariantArea = true;
      },
      "mouseleave": function mouseleave($event) {
        _vm.hoverVariantArea = false;
      }
    }
  }, [_c('div', {
    staticClass: "d-flex justify-content-center list-unstyled px-1 px-md-3 list"
  }, [_vm._l(_vm.displayedVariants, function (variant, index) {
    return _c('a', {
      key: "".concat(variant.reference, "-").concat(index),
      staticClass: "item px-md-1 text-center",
      class: {
        active: variant.reference === _vm.currentItem.reference
      },
      attrs: {
        "href": _vm.buildProductUrl(_vm.locale, variant.slug, variant.reference)
      }
    }, [_c('div', {
      staticClass: "rounded-circle text-center d-inline-block pellet",
      on: {
        "mouseenter": function mouseenter($event) {
          return _vm.$emit('onHoverVariant');
        },
        "mouseover": function mouseover($event) {
          _vm.hoverVariant = variant;
        }
      }
    }, [_vm.lazySeo ? _c('img', {
      staticClass: "d-block variant-crop-image",
      attrs: {
        "srcset": variant.images[0].thumbnail,
        "alt": variant.name,
        "data-sizes": "auto",
        "loading": "lazy"
      }
    }) : _vm._e(), _vm._v(" "), _vm.lazyPoly ? _c('img', {
      staticClass: "lazyload d-block variant-crop-image",
      attrs: {
        "data-srcset": variant.images[0].thumbnail,
        "alt": variant.name,
        "data-sizes": "auto"
      }
    }) : _vm._e(), _vm._v(" "), _vm.noLazy ? _c('img', {
      staticClass: "d-block variant-crop-image",
      attrs: {
        "srcset": variant.images[0].thumbnail,
        "alt": variant.name,
        "data-sizes": "auto",
        "loading": "eager"
      }
    }) : _vm._e()])]);
  }), _vm._v(" "), _vm.totalVariants ? _c('div', {
    staticClass: "px-1 text-center"
  }, [_c('a', {
    staticClass: "d-flex justify-content-center align-items-center px-1 text-center leftovers",
    attrs: {
      "href": _vm.buildProductUrl(_vm.locale, _vm.currentItem.slug, _vm.currentItem.reference)
    }
  }, [_c('span', {
    staticClass: "leftovers-counter d-none d-md-flex align-items-center px-1",
    domProps: {
      "textContent": _vm._s("+".concat(_vm.totalVariants.desktop))
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "leftovers-counter d-block d-md-none d-lg-none",
    domProps: {
      "textContent": _vm._s("+".concat(_vm.totalVariants.mobile))
    }
  })])]) : _vm._e()], 2)])] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "link px-1 pb-0",
    class: {
      'mt-1': !_vm.variantsVisibility
    }
  }, [_c('div', [_c('ProductFlags', {
    attrs: {
      "flags": _vm.flagsDisplayed
    }
  })], 1), _vm._v(" "), _vm.product.brand && _vm.brandMarketplace ? _c('span', {
    staticClass: "brand d-block pb-1",
    domProps: {
      "textContent": _vm._s(_vm.product.brand)
    }
  }) : _vm._e(), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.buildProductUrl(_vm.locale, _vm.currentItem.slug, _vm.currentItem.reference)
    },
    on: {
      "click": function click($event) {
        return _vm.goToProduct($event);
      }
    }
  }, [_c('h2', {
    staticClass: "font-weight-normal expand-link name mb-0",
    domProps: {
      "textContent": _vm._s(_vm.formattedName)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "pl-1 align-items-end pt-1"
  }, [_c('div', {
    staticClass: "ml-auto d-md-inline price"
  }, [_c('span', {
    staticClass: "font-weight-bold mr-1 d-block d-sm-inline",
    domProps: {
      "textContent": _vm._s(_vm.currentPrice)
    }
  }), _vm._v(" "), _vm.product.price.sales.amount ? _c('s', {
    staticClass: "sales",
    domProps: {
      "textContent": _vm._s(_vm.product.price.base.formatted)
    }
  }) : _vm._e(), _vm._v(" "), _c('ProductFlags', {
    staticClass: "flag-sales",
    attrs: {
      "flags": _vm.flagsSales,
      "is-on-sales": ""
    }
  })], 1)]), _vm._v(" "), _vm.product.sponsored ? _c('div', {
    staticClass: "px-1 product-item_sponsored"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('sponsored')) + "\n    ")]) : _vm._e()], 2)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };